/**
 * Repair and normalize URL search strings for routing and analytics.
 */

const TRACKING_KEYS_TO_DROP = new Set(['gtm_latency']);

/**
 * Collapse extra "?" into "&" and keep the first value for each key.
 *
 * @param {string} [search] - location.search, with or without leading "?"
 * @returns {string} Search starting with "?" or empty string
 */
export const repairSearch = (search) => {
  if (!search) {
    return '';
  }
  const raw = search.startsWith('?') ? search.slice(1) : search;
  if (!raw) {
    return '';
  }
  const collapsed = raw.replace(/\?/g, '&');
  const params = new URLSearchParams(collapsed);
  const next = new URLSearchParams();
  params.forEach((value, key) => {
    if (!key || next.has(key)) {
      return;
    }
    next.set(key, value);
  });
  const serialized = next.toString();
  return serialized ? `?${serialized}` : '';
};

/**
 * Search string safe to send to GA4 (debug params removed).
 *
 * @param {string} [search]
 * @returns {string}
 */
export const trackingSearch = (search) => {
  const repaired = repairSearch(search);
  if (!repaired) {
    return '';
  }
  const params = new URLSearchParams(repaired.slice(1));
  TRACKING_KEYS_TO_DROP.forEach((key) => {
    params.delete(key);
  });
  const serialized = params.toString();
  return serialized ? `?${serialized}` : '';
};
